var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "glass-container" },
    [
      !_vm.$screen.mobile
        ? [
            _c("div", { staticClass: "max-bet-container" }, [
              _c("span", { staticClass: "max-bet-title" }, [_vm._v("难度")]),
              _c("div", { staticClass: "max-bet-info" }, [
                _c(
                  "span",
                  { staticClass: "max-bet-sublabel" },
                  [
                    !_vm.streamerMode
                      ? [_vm._v("最大倍率")]
                      : [_vm._v("最大距离")],
                  ],
                  2
                ),
                _c("div", { staticClass: "multiplier-badge" }, [
                  _c("span", { staticClass: "multiplier-text" }, [
                    _vm._v("x" + _vm._s(_vm.formattedMaxMultiplier)),
                  ]),
                  _c("img", {
                    staticClass: "multiplier-light",
                    attrs: { src: require("./assets/light.webp"), alt: "" },
                  }),
                ]),
              ]),
            ]),
          ]
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "buttons-wrapper",
          class: { "is-disabled": _vm.disabled },
        },
        _vm._l(_vm.difficultyButtons, function (item, index) {
          return _c(
            "button",
            {
              key: index,
              staticClass: "difficulty-btn",
              class:
                _vm.selectedIndex === index
                  ? "difficulty-btn--active"
                  : "difficulty-btn--inactive",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.setDifficulty(index)
                },
              },
            },
            [
              _c("div", { staticClass: "btn-content" }, [
                _c("span", { staticClass: "btn-text" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _vm.$screen.mobile
        ? [
            _c("div", { staticClass: "max-bet-container" }, [
              _c("div", { staticClass: "max-bet-info" }, [
                _c(
                  "span",
                  { staticClass: "max-bet-sublabel" },
                  [
                    !_vm.streamerMode
                      ? [_vm._v("最大倍率")]
                      : [_vm._v("最大距离")],
                  ],
                  2
                ),
                _c("div", { staticClass: "multiplier-badge" }, [
                  _c("span", { staticClass: "multiplier-text" }, [
                    _vm._v("x" + _vm._s(_vm.formattedMaxMultiplier)),
                  ]),
                  _c("img", {
                    staticClass: "multiplier-light",
                    attrs: { src: require("./assets/light.webp"), alt: "" },
                  }),
                ]),
              ]),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }